import { useUserLogout } from "api/user";
import Loader from "components/Loader";
import useUser from "context/hooks/user";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import axiosInstance from "utils/axios";
import { showToast } from "utils/toast";

export default function AskForActivate() {
  const { data } = useUser();
  const { dir, tenant: tenantDetail } = useAppSelector(getSettings);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const { mutate: logout, isPending: loggingUserOut } = useUserLogout();

  useEffect(() => {
    let timerVar = setInterval(() => {
      if (timer > 0) setTimer(timer - 1);
      else {
        clearInterval(timerVar);
      }
    }, 1000);
    return () => {
      clearInterval(timerVar);
    };
  }, [timer]);

  function handleResendCode() {
    if (timer > 0) return;
    setLoading(true);
    axiosInstance
      .post(`keys/resend-key-activate`)
      .then((res) => res.data)
      .then((data) => {
        setLoading(false);
        if (data.statusCode === 200) {
          showToast(t("resendEmail"), "success");
          setTimer(30);
        } else {
          showToast(t("couldNotResendEmail"), "error");
        }
      })
      .catch((err) => {
        setLoading(false);
        showToast(t("couldNotResendEmail"), "error");
      });
  }

  return (
    <>
      <Loader open={loading || loggingUserOut} />
      <div dir={dir}>
        <div className="flex items-center justify-between">
          <img
            src={require("../assets/logo/nexme_logo.png")}
            alt="Nexme"
            className="w-[25vw] md:w-44 h-20 object-contain"
          />
          {tenantDetail &&
            (tenantDetail?.profile_image ? (
              <img
                src={tenantDetail?.profile_image}
                alt={tenantDetail?.institution_title}
                className="w-[25vw] md:w-44 h-20 object-contain"
              />
            ) : (
              <h2 className="font-bold text-2xl">{tenantDetail?.initials}</h2>
            ))}
        </div>
        <div className="h-[calc(100vh-80px)] flex flex-col gap-y-10 items-center justify-center">
          <h2 className="font-medium text-4xl text-center mt-auto">
            {t("signupWelcome")}&nbsp;
            <span className="capitalize font-bold">{data?.username ?? ""}</span>
            !
          </h2>
          <p className="text-center px-3 md:px-0">
            {t("ActivateKeyCheckEmailTitleActivateKeyPage", {
              email: data.email,
            })}
          </p>
          <button
            className={`text-gray-600 underline font-medium py-1 px-4 rounded-full focus:outline-none focus:shadow-outline text-sm disabled:opacity-50 ${
              timer > 0 ? "cursor-not-allowed" : "cursor-pointer"
            }`}
            onClick={handleResendCode}
            disabled={timer > 0}
          >
            {timer
              ? `${t("otpPageSendAgainText")} ${timer} ${t(
                  "otpPageSecondsCountText"
                )}`
              : t("ActivateKeyResendEmail")}
          </button>
          <button
            className="text-gray-600 underline font-medium py-1 px-4 rounded-full focus:outline-none focus:shadow-outline text-sm disabled:opacity-50 my-auto"
            onClick={logout}
          >
            {t("logOutMenuItem")}
          </button>
        </div>
      </div>
    </>
  );
}
